import getLogoSrc from '../logoUtils';

const pick = (...values) => values.find((value) => value !== undefined && value !== null && value !== '');

export const defaultPdfBrandingProvider = (appSettings = {}, userProfile = null, overrides = {}) => {
  const organisation = userProfile?.organisation || {};
  const orgName = pick(
    organisation.orgName,
    organisation.name,
    userProfile?.company,
    'Asset Metrics'
  );
  const orgLogoRaw = pick(
    overrides.logo,
    appSettings?.pdf_report_logo?.value,
    organisation.orgLogo,
    organisation.org_logo,
    userProfile?.orgLogo,
    userProfile?.org_logo,
    userProfile?.organisationLogo
  );
  const logo = orgLogoRaw ? getLogoSrc(orgLogoRaw) : '/assets/images/logo.png';

  return {
    companyName: pick(overrides.companyName, appSettings?.pdf_company_name?.value, orgName),
    headerTitle: pick(overrides.headerTitle, appSettings?.pdf_header_title?.value, 'Report Export'),
    headerSubtitle: pick(overrides.headerSubtitle, appSettings?.pdf_header_subtitle?.value, orgName),
    footerLeft: pick(overrides.footerLeft, appSettings?.pdf_footer_left?.value, orgName),
    footerRight: pick(overrides.footerRight, appSettings?.pdf_footer_right?.value, 'Generated by AM Platform'),
    footerLogo: pick(overrides.footerLogo, '/assets/images/logo-icon.png'),
    footerPoweredBy: pick(overrides.footerPoweredBy, 'Powered By Samurai'),
    logo,
  };
};

export default defaultPdfBrandingProvider;
